export default function leadZero(int) {
  return (int >= 0 && int < 10) ? (`0${int}`) : int;
}



// WEBPACK FOOTER //
// ./scripts/utils/lead-zero.js